module.exports = __webpack_public_path__ + "static/img/printNotice1.eac45f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/printNotice1.png
// module id = EA1p
// module chunks = 2